import { screen_lg, screen_md, screen_sm, screen_xl, screen_xl2 } from "@/style/theme";
import { useWindowSize } from "@uidotdev/usehooks";

export type ScreenSize = "sm" | "md" | "lg" | "xl" | "xl2" | "sm_" | "md_" | "lg_" | "xl_" | "xl2_";

export const useIsScreenSizeMatched = (screenSizes: ScreenSize[]): boolean => {
  const { width, height } = useWindowSize();

  if (!width || !height) {
    return false;
  }

  if (width < screen_sm) {
    if (screenSizes.includes("sm")) {
      return true;
    }
  }

  if (width < screen_md) {
    if (screenSizes.includes("md")) {
      return true;
    }
  }

  if (width < screen_lg) {
    if (screenSizes.includes("lg")) {
      return true;
    }
  }

  if (width < screen_xl) {
    if (screenSizes.includes("xl")) {
      return true;
    }
  }

  if (width < screen_xl2) {
    if (screenSizes.includes("xl2")) {
      return true;
    }
  }

  if (width > screen_sm) {
    if (screenSizes.includes("sm_")) {
      return true;
    }
  }

  if (width > screen_md) {
    if (screenSizes.includes("md_")) {
      return true;
    }
  }

  if (width > screen_lg) {
    if (screenSizes.includes("lg_")) {
      return true;
    }
  }

  if (width > screen_xl) {
    if (screenSizes.includes("xl_")) {
      return true;
    }
  }

  if (width > screen_xl2) {
    if (screenSizes.includes("xl2_")) {
      return true;
    }
  }

  return false;
};
